import script from "./EditNews.vue?vue&type=script&lang=ts&setup=true"
export * from "./EditNews.vue?vue&type=script&lang=ts&setup=true"

import "./EditNews.vue?vue&type=style&index=0&id=b676ff2c&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b676ff2c"]])

export default __exports__